import { type ReviewsViewContext } from "@src/appV2/redesign/ShiftDiscovery/useWorkplaceModalsDataContext";
import { type IconType } from "@src/appV2/redesign/system/ui-components/components/CbhIcon";
import { IconWithCountButton } from "@src/appV2/redesign/system/ui-components/components/IconWithCountButton";
import { useDeleteCommentReaction } from "@src/appV2/redesign/Workplace/Review/api/useDeleteCommentReaction";
import { usePostCommentReaction } from "@src/appV2/redesign/Workplace/Review/api/usePostCommentReaction";
import { type WorkplaceCommentType } from "@src/appV2/redesign/Workplace/Review/api/useWorkplaceComments";

import { type CommentReactionSource, Reaction } from "../types";

const REACTION_CONFIG: Record<Reaction, { base: IconType; active: IconType; label: string }> = {
  [Reaction.LIKE]: { base: "thumb-up-outlined", active: "thumb-up-filled", label: "Like reaction" },
  [Reaction.DISLIKE]: {
    base: "thumb-down-outlined",
    active: "thumb-down-filled",
    label: "Dislike reaction",
  },
};

interface ReactionButtonProps {
  reactionType: Reaction;
  isActive: boolean;
  count: number;
  workplaceId: string;
  commentId: string;
  source: CommentReactionSource;
  viewContext: ReviewsViewContext;
  onReactionChanged: (comment: WorkplaceCommentType) => void;
}

export function ReactionButton(props: ReactionButtonProps) {
  const {
    reactionType,
    isActive,
    count,
    workplaceId,
    commentId,
    source,
    viewContext,
    onReactionChanged,
  } = props;

  const config = REACTION_CONFIG[reactionType];

  const { mutate: postCommentReaction } = usePostCommentReaction(
    { workplaceId, commentId, source, viewContext },
    {
      onSuccess: (data) => {
        onReactionChanged(data.data);
      },
    }
  );

  const { mutate: deleteCommentReaction } = useDeleteCommentReaction(
    { workplaceId, commentId, source, viewContext },
    {
      onSuccess: (data) => {
        onReactionChanged(data.data);
      },
    }
  );

  return (
    <IconWithCountButton
      aria-label={config.label}
      isActive={isActive}
      count={count}
      baseIconType={config.base}
      activeIconType={config.active}
      onClick={(event) => {
        event.stopPropagation();

        if (isActive) {
          deleteCommentReaction({ reactionType });
        } else {
          postCommentReaction({ reaction: reactionType });
        }
      }}
    />
  );
}
